const data=[
        {
            id:1,
            title:'Agency Website',
            language:'javascript',
            image:'../img/workree.png',
            details:'Reactjs,Vanilla CSS'
        },
        {
            id:2,
            title:'School Website',
            language:'Bootstrap',
            image:'../img/school.png',
            details:'Bootstrap'
            
        },
        {
            id:3,
            title:'Brewery Website',
            language:'CSS',
            image:'../img/Yak.png',
            details:'Vanilla CSS'
        },
        {
            id:4,
            title:'Portfolio Website',
            language:'CSS',
            image:'../img/Portfolio.png',
            details:'Vanilla CSS'
        },
        {
            id:5,
            title:'Tutorial Blog',
            language:'javascript',
            image:'../img/Tutorial.png',
            details:'Reactjs'
        },
        {
            id:6,
            title:'Egg Game',
            language:'javascript',
            image:'../img/egggame.png',
            details:'Vanilla JS'
        },
        {
            id:7,
            title:'Photo Studio Website',
            language:'Bootstrap',
            image:'../img/PhotoStudio.png',
            details:'Bootstrap'

        }
    ]
export default data;